import React from 'react';

export const InstantIcon = ({ fill = '#0099C7' }) => {
  return (
    <>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.75"
          y="0.75"
          width="30.5"
          height="30.5"
          rx="3.25"
          stroke={fill}
          strokeWidth="1.5"
          strokeLinecap="square"
        />
        <rect x="18" y="9" width="8" height="1.5" rx="0.75" fill={fill} />
        <rect x="18" y="12" width="6" height="1.5" rx="0.75" fill={fill} />
        <rect x="18" y="22" width="6" height="1.5" rx="0.75" fill={fill} />
        <path
          d="M7 21.5L9.54545 24L14 19"
          stroke={fill}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 14L12 9L7 14Z"
          stroke={fill}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 9L12 14L7 9Z"
          stroke={fill}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect x="18" y="19" width="8" height="1.5" rx="0.75" fill={fill} />
      </svg>
    </>
  );
};
